import React from 'react';
import CaseNote from './CaseNote';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onSuccess?: () => void;
	note?: {
		id: string;
		text: string;
	};
	caseId: string;
}
const CaseNoteModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			size={Size.SM}
			title={props.note ? 'base.shared.editNote' : 'base.shared.addNote'}>
			<CaseNote
				note={props.note}
				onSuccess={props.onSuccess}
				caseId={props.caseId}
			/>
		</BaseModal>
	);
};

export default CaseNoteModal;
